import { FC, useCallback } from "react";
import { useCompleteInviteOnboardingMutation } from "@api/userOnboarding.api";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useScope } from "@state/scopeContext.lib";
import { BaseOnboardingContainer } from "../components/BaseOnboardingContainer";
import { InviteFlow } from "../flows/InviteFlow";

export const InviteOnboardingContainer: FC = () => {
    const completeInviteOnboardingMutation =
        useCompleteInviteOnboardingMutation();
    const navigate = useStateAwareNavigate();
    const { workspaceId, organizationId } = useScope();

    const onFinish = useCallback(async () => {
        await completeInviteOnboardingMutation.mutateAsync({
            workspaceId,
            organizationId,
        });

        navigate("/");
    }, [
        completeInviteOnboardingMutation,
        navigate,
        workspaceId,
        organizationId,
    ]);

    return (
        <BaseOnboardingContainer logoutButtonSize="lg">
            <InviteFlow onFinish={onFinish} />
        </BaseOnboardingContainer>
    );
};
